/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type HTTPValidationError,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
} from '../models/HTTPValidationError';
import {
    type SenderInviteRequest,
    SenderInviteRequestFromJSON,
    SenderInviteRequestToJSON,
} from '../models/SenderInviteRequest';
import {
    type SenderListResponse,
    SenderListResponseFromJSON,
    SenderListResponseToJSON,
} from '../models/SenderListResponse';
import {
    type SenderRemoveRequest,
    SenderRemoveRequestFromJSON,
    SenderRemoveRequestToJSON,
} from '../models/SenderRemoveRequest';
import {
    type SenderUpsertRequest,
    SenderUpsertRequestFromJSON,
    SenderUpsertRequestToJSON,
} from '../models/SenderUpsertRequest';
import {
    type SenderUpsertResponse,
    SenderUpsertResponseFromJSON,
    SenderUpsertResponseToJSON,
} from '../models/SenderUpsertResponse';

export interface InviteSenderRequest {
    /**
     * 
     */
    senderInviteRequest: SenderInviteRequest;
    /**
     * 
     */
    accessToken?: string | null;
}

export interface ListSendersRequest {
    /**
     * 
     */
    body: object;
    /**
     * 
     */
    accessToken?: string | null;
}

export interface RemoveSenderRequest {
    /**
     * 
     */
    senderRemoveRequest: SenderRemoveRequest;
    /**
     * 
     */
    accessToken?: string | null;
}

export interface UpsertSenderRequest {
    /**
     * 
     */
    senderUpsertRequest: SenderUpsertRequest;
    /**
     * 
     */
    accessToken?: string | null;
}

/**
 * 
 */
export class SendersApi extends runtime.BaseAPI {

    /**
     * Creates request options for inviteSender without sending the request
     */
    async inviteSenderRequestOpts(requestParameters: InviteSenderRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['senderInviteRequest'] == null) {
            throw new runtime.RequiredError(
                'senderInviteRequest',
                'Required parameter "senderInviteRequest" was null or undefined when calling inviteSender().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/senders/invite`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SenderInviteRequestToJSON(requestParameters['senderInviteRequest']),
        };
    }

    /**
     * Invite Sender
     */
    async inviteSenderRaw(requestParameters: InviteSenderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const requestOptions = await this.inviteSenderRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Invite Sender
     */
    async inviteSender(requestParameters: InviteSenderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.inviteSenderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listSenders without sending the request
     */
    async listSendersRequestOpts(requestParameters: ListSendersRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling listSenders().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/senders/list`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        };
    }

    /**
     * List Senders
     */
    async listSendersRaw(requestParameters: ListSendersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SenderListResponse>> {
        const requestOptions = await this.listSendersRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SenderListResponseFromJSON(jsonValue));
    }

    /**
     * List Senders
     */
    async listSenders(requestParameters: ListSendersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SenderListResponse> {
        const response = await this.listSendersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for removeSender without sending the request
     */
    async removeSenderRequestOpts(requestParameters: RemoveSenderRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['senderRemoveRequest'] == null) {
            throw new runtime.RequiredError(
                'senderRemoveRequest',
                'Required parameter "senderRemoveRequest" was null or undefined when calling removeSender().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/senders/remove`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SenderRemoveRequestToJSON(requestParameters['senderRemoveRequest']),
        };
    }

    /**
     * Remove Sender
     */
    async removeSenderRaw(requestParameters: RemoveSenderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.removeSenderRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove Sender
     */
    async removeSender(requestParameters: RemoveSenderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeSenderRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for upsertSender without sending the request
     */
    async upsertSenderRequestOpts(requestParameters: UpsertSenderRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['senderUpsertRequest'] == null) {
            throw new runtime.RequiredError(
                'senderUpsertRequest',
                'Required parameter "senderUpsertRequest" was null or undefined when calling upsertSender().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/senders/upsert`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SenderUpsertRequestToJSON(requestParameters['senderUpsertRequest']),
        };
    }

    /**
     * Upsert Sender
     */
    async upsertSenderRaw(requestParameters: UpsertSenderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SenderUpsertResponse>> {
        const requestOptions = await this.upsertSenderRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SenderUpsertResponseFromJSON(jsonValue));
    }

    /**
     * Upsert Sender
     */
    async upsertSender(requestParameters: UpsertSenderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SenderUpsertResponse> {
        const response = await this.upsertSenderRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
